import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as todayItemsService from '_services/today-items'

export const GET_TODAY_ITEMS = defineAction('GET_TODAY_ITEMS')
export const SET_TODAY_ITEMS_ORDER = defineAction('SET_TODAY_ITEMS_ORDER')
export const DELETE_TODAY_ITEM = defineAction('DELETE_TODAY_ITEM')
export const CREATE_TODAY_ITEM = defineAction('CREATE_TODAY_ITEM')
export const UPDATE_TODAY_ITEM = defineAction('UPDATE_TODAY_ITEM')
export const UPDATE_TODAY_ITEM_DATE = defineAction('UPDATE_TODAY_ITEM_DATE')
export const COMPLETE_TODAY_ITEM = defineAction('COMPLETE_TODAY_ITEM')
export const UNDO_TODAY_ITEM = defineAction('UNDO_TODAY_ITEM')

export const getTodayItems = () => (dispatch, getState) =>
  dispatch({
    type: GET_TODAY_ITEMS.ACTION,
    payload: todayItemsService.getTodayItems(getState().user.get('token'))(),
  })

export const setTodayItemsOrder = payload => (dispatch, getState) =>
  dispatch({
    type: SET_TODAY_ITEMS_ORDER.ACTION,
    payload: todayItemsService
      .setTodayItemsOrder(getState().user.get('token'))(payload)
      .then(() => todayItemsService.getTodayItems(getState().user.get('token'))()),
  })

export const deleteTodayItem = id => (dispatch, getState) =>
  dispatch({
    type: DELETE_TODAY_ITEM.ACTION,
    payload: todayItemsService
      .deleteTodayItem(getState().user.get('token'))(id)
      .then(() => id),
  })

export const createTodayItem = payload => (dispatch, getState) =>
  dispatch({
    type: CREATE_TODAY_ITEM.ACTION,
    payload: todayItemsService
      .createTodayItem(getState().user.get('token'))(payload)
      .then(() => todayItemsService.getTodayItems(getState().user.get('token'))()),
  })

export const editTodayItem = (id, payload) => (dispatch, getState) =>
  dispatch({
    type: UPDATE_TODAY_ITEM.ACTION,
    payload: todayItemsService
      .updateTodayItem(getState().user.get('token'))(id, payload)
      .then(() => todayItemsService.getTodayItems(getState().user.get('token'))()),
  })

export const updateTodayItemDate = id => (dispatch, getState) =>
  dispatch({
    type: UPDATE_TODAY_ITEM_DATE.ACTION,
    payload: todayItemsService
      .updateTodayItemDate(getState().user.get('token'))(id)
      .then(() => todayItemsService.getTodayItems(getState().user.get('token'))()),
  })

export const completeTodayItem = payload => (dispatch, getState) =>
  dispatch({
    type: COMPLETE_TODAY_ITEM.ACTION,
    payload: todayItemsService
      .completeTodayItem(getState().user.get('token'))(payload)
      .then(() => todayItemsService.getTodayItems(getState().user.get('token'))()),
  })

export const undoTodayItem = () => (dispatch, getState) =>
  dispatch({
    type: UNDO_TODAY_ITEM.ACTION,
    payload: todayItemsService
      .undoTodayItem(getState().user.get('token'))
      .then(() => todayItemsService.getTodayItems(getState().user.get('token'))()),
  })



// WEBPACK FOOTER //
// ./src/modules/today-items/actions.js